import { Box, styled } from '@mui/material';

const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

const StyledLargeSessionCardInnerContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.raised,
  borderBottomRightRadius: '12px',
  borderTopRightRadius: '12px',
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  transition: `background-color 0.2s ${EASE}, transform 0.2s ${EASE}`,
  '&:hover': {
    backgroundColor: theme.palette.surface.hover,
    transform: 'translateY(-2px)'
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  }
}));

export default StyledLargeSessionCardInnerContainer;
